/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Group, Stack, Text, TextInput, Loader, NumberInput, Checkbox, Title, Divider } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import CNPJInput from "@/components/cnpj-input";
import TelInput from "@/components/tel-input";
import { LicenciadaStepProperties } from "../types";

export const LicenciadaInfoStep = ({ form, isFetchingCnpj }: LicenciadaStepProperties) => {

  return (
    <Stack gap="sm" mt="md">
      <Title order={3} mb="xs">Passo 1: Cadastro da Licenciada</Title>
      <Text size="sm" c="dimmed" mb="md">
        Preencha as informações da licenciada que será criada no sistema
      </Text>
      <Divider mb="md" />

      <Text size="sm" fw={500} mb="xs">
        Dados Básicos
      </Text>
      <Group>
        <CNPJInput
          label="CNPJ"
          placeholder="00.000.000/0000-00"
          style={{ flex: 1 }}
          rightSection={isFetchingCnpj ? <Loader size="xs" /> : null}
          {...form.getInputProps("novaLicenciada.cnpj")}
          required
        />
        <TextInput
          label="Razão Social"
          style={{ flex: 2 }}
          {...form.getInputProps("novaLicenciada.razaoSocial")}
          required
        />
        <TextInput
          label="Nome Fantasia"
          style={{ flex: 2 }}
          {...form.getInputProps("novaLicenciada.nomeFantasia")}
          required
        />
      </Group>
      <Group grow>
        <TextInput label="Email" type="email" {...form.getInputProps("novaLicenciada.email")} required />
        <TelInput label="Telefone" {...form.getInputProps("novaLicenciada.telefone")} required />
      </Group>

      <Text size="sm" fw={500} mt="md" mb="xs">
        Contrato
      </Text>
      <Group grow>
        <DateInput
          label="Início do Contrato"
          placeholder="Selecione a data"
          {...form.getInputProps("novaLicenciada.contratoInicio")}
          required
        />
        <DateInput
          label="Fim do Contrato"
          placeholder="Selecione a data"
          {...form.getInputProps("novaLicenciada.contratoFim")}
          required
        />
      </Group>

      <Text size="sm" fw={500} mt="md" mb="xs">
        Endereço
      </Text>
      <Group>
        <TextInput
          label="CEP"
          placeholder="00000-000"
          style={{ flex: 1 }}
          {...form.getInputProps("novaLicenciada.endereco.cep")}
          required
        />
        <TextInput
          label="Cidade"
          style={{ flex: 3 }}
          {...form.getInputProps("novaLicenciada.endereco.cidade")}
          required
        />
        <TextInput
          label="Estado"
          placeholder="SP"
          style={{ flex: 0.5, maxWidth: "80px" }}
          {...form.getInputProps("novaLicenciada.endereco.estado")}
          required
        />
      </Group>
      <TextInput label="Logradouro" {...form.getInputProps("novaLicenciada.endereco.logradouro")} required />
      <Group grow>
        <TextInput label="Número" {...form.getInputProps("novaLicenciada.endereco.numero")} required />
        <TextInput label="Complemento" {...form.getInputProps("novaLicenciada.endereco.complemento")} />
        <TextInput label="Bairro" {...form.getInputProps("novaLicenciada.endereco.bairro")} required />
      </Group>

      <Text size="sm" fw={500} mt="md" mb="xs">
        Acessos
      </Text>
      <Group grow>
        <NumberInput
          label="Admin"
          min={0}
          {...form.getInputProps("novaLicenciada.acessos.admin")}
          required
        />
        <NumberInput
          label="Member"
          min={0}
          {...form.getInputProps("novaLicenciada.acessos.member")}
          required
        />
        <NumberInput
          label="Team"
          min={0}
          {...form.getInputProps("novaLicenciada.acessos.team")}
          required
        />
      </Group>
      <Group grow>
        <NumberInput
          label="Master"
          min={0}
          {...form.getInputProps("novaLicenciada.acessos.master")}
          required
        />
        <NumberInput
          label="Collaborator"
          min={0}
          {...form.getInputProps("novaLicenciada.acessos.collaborator")}
          required
        />
      </Group>

      <Text size="sm" fw={500} mt="md" mb="xs">
        Autorizações
      </Text>
      <Group grow>
        <Checkbox
          label="Gestão"
          {...form.getInputProps("novaLicenciada.autorizacoes.gestao", { type: "checkbox" })}
        />
        <Checkbox
          label="Diagnóstico"
          {...form.getInputProps("novaLicenciada.autorizacoes.diagnostico", { type: "checkbox" })}
        />
        <Checkbox
          label="Incentivo"
          {...form.getInputProps("novaLicenciada.autorizacoes.incentivo", { type: "checkbox" })}
        />
        <Checkbox
          label="Configurações"
          checked={true}
          disabled
          {...form.getInputProps(
            "novaLicenciada.autorizacoes.configuracoes",
            { type: "checkbox" }
          )}
        />
      </Group>

    </Stack>
  );
};
